import * as React from 'react';
import './_HelpPanelLinksComponent.scss';
import { HelpPanelVideoLinkHOC } from '../../hocs/HelpPanelVideoLinkHOC/HelpPanelVideoLinkHOC';
import { HelpPanelAffiliateLinkHOC } from '../../hocs/HelpPanelAffiliateLinkHOC/HelpPanelAffiliateLinkHOC';
import { HelpPanelInviteLinkHOC } from '../../hocs/HelpPanelInviteLinkHOC/HelpPanelInviteLinkHOC';
import {HelpPanelReleaseNotesHOC} from '../../hocs/HelpPanelReleaseNotesHOC/HelpPanelReleaseNotesHOC';
import { HelpPanelFAQHOC } from '../../hocs/HelpPanelFAQHOC/HelpPanelFAQHOC';

export const HelpPanelLinksComponent = () => {
    return (
        <div className={'help-panel__links'}>
            <HelpPanelFAQHOC />
            <HelpPanelVideoLinkHOC />
            <HelpPanelAffiliateLinkHOC />
            <HelpPanelInviteLinkHOC />
            <HelpPanelReleaseNotesHOC />
        </div>
    );
};
